import React from 'react';

const CONFIG: Record<string, { label: string; bg: string; color: string }> = {
  running:   { label: 'Running',   bg: '#1e1b4b', color: '#818cf8' },
  completed: { label: 'Completed', bg: '#14532d', color: '#4ade80' },
  failed:    { label: 'Failed',    bg: '#450a0a', color: '#f87171' },
};

export default function JobStatusBadge({ status }: { status: string }) {
  const cfg = CONFIG[status] ?? { label: status, bg: '#1e293b', color: '#94a3b8' };
  return (
    <span style={{
      display: 'inline-block',
      padding: '2px 8px',
      borderRadius: 4,
      fontSize: 11,
      fontWeight: 600,
      background: cfg.bg,
      color: cfg.color,
      textTransform: 'uppercase',
      letterSpacing: '0.05em',
    }}>
      {cfg.label}
    </span>
  );
}
